var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"188c9bd004ded030a8a139e9c942a25c0ff5b80c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@eprezto"]={id:"188c9bd004ded030a8a139e9c942a25c0ff5b80c"};
      